import { useEffect, useState } from "react";
import { regions as regionsService } from "../../../api/regions.service";

type RegionOption = {
  value: string;
  label: string;
};

export function useRegionOptions() {
  const [regionOptions, setRegionOptions] = useState<RegionOption[]>([
    { value: "", label: "Select a region..." },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchRegions = async () => {
      setIsLoading(true);
      try {
        const response = await regionsService.getAll();
        setRegionOptions([
          { value: "", label: "Select a region..." },
          ...response.map(region => ({
            value: String(region.id),
            label: region.name,
          })),
        ]);
      } catch (err) {
        console.error("Failed to fetch regions:", err);
        setError(err instanceof Error ? err : new Error("Failed to fetch regions"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchRegions();
  }, []);

  return { regionOptions, isLoading, error };
}
